export default "__VITE_ASSET__oe6WLdnY__"